import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber',
  standalone: true
})
export class FormatNumberPipe implements PipeTransform {
  transform(
    value: number,
    fractionDigits: number = 2,
    separator: string = ' '
  ): string {
    if (value == null || isNaN(value)) {
      return '';
    }

    const options: Intl.NumberFormatOptions = {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      useGrouping: true
    };

    let formattedNumber = new Intl.NumberFormat('en-US', options).format(value);

    if (separator) {
      formattedNumber = formattedNumber.replace(/,/g, separator === ' ' ? '\u00A0' : separator);
    }

    return formattedNumber;
  }
}
